module.exports = __webpack_public_path__ + "static/media/btn-arrow-gradeinte-o.43da6b97.svg";